import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import styles from '../style';
import { withRouter } from 'react-router-dom';
import {
  TextField,
  Box,
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@material-ui/core';
import { connect } from 'react-redux';
import validate from 'validate.js';
import schema from './schema';
import { sendInvite } from 'services/ptmessages/action';
const SendActivation = props => {
  const {
    classes,
    patient,
    ehrID,
    poploading } = props;

  const [values, setValues] = useState({
    // id: 0,
    lastname: '',
    firstname: '',
    mobilenumber: '',
    emailaddress: '',
    confirmEmailaddress: '',
    roles: 'ROLE_USER ROLE_PATIENT',
    isValid: false,
    touched: {},
    errors: {}
  });


  const [country, setCountry] = React.useState('US');
  const [phoneError, setPhoneError] = React.useState('');

  const phoneRegex = {
    US: /^(\+?1)?[2-9]\d{2}[2-9]\d{6}$/,
    CA: /^(\+?1)?[2-9]\d{2}[2-9]\d{6}$/,
    IN: /^(\+?91)?[6-9]\d{9}$/
  };

  const validatePhone = (phoneNumber, countryCode) => {
    const cleaned = phoneNumber.replace(/[\s\-\(\)]/g, '');

    if (!cleaned) {
      setPhoneError('Mobile number is required');
      return false;
    }

    if (!phoneRegex[countryCode].test(cleaned)) {
      setPhoneError(`Invalid ${countryCode} phone number format`);
      return false;
    }

    setPhoneError('');
    return true;
  };

  const handlePhoneChange = (event) => {
    const value = event.target.value;
    handleChange('mobilenumber', value);
    validatePhone(value, country);
  };

  const handleCountryChange = (event) => {
    const newCountry = event.target.value;
    setCountry(newCountry);
    if (values.mobilenumber) {
      validatePhone(values.mobilenumber, newCountry);
    }
  };

  useEffect(() => {
    if (patient !== undefined) {
      setValues({
        ...values,
        // id: patient.id,
        lastname: patient.lastname,
        firstname: patient.firstname
      });
    }
  }, [patient]);

  const handleSendActivation = () => {
    if (values.isValid) {
      const newState = { ...values };
      newState.mobilenumber = country === 'IN' ? '+91' + newState.mobilenumber : '+1' + newState.mobilenumber;
      console.log('newState', newState);
      props.handleSendActivation(ehrID, patient.id, newState);
    }
  };

  const hasError = field =>
    values &&
      values.touched &&
      values.errors &&
      values.touched[field] &&
      values.errors[field]
      ? true
      : false;

  const handleChange = (field, value) => {
    const newState = { ...values };
    newState[field] = value;
    newState.touched[field] = true;
    const errors = validate(newState, schema);
    newState.errors = errors || {};
    newState.isValid = errors ? false : true;

    setValues(newState);
  };

  return (
    <React.Fragment>
      <Box className={classes.modalBody}>
        <TextField
          placeholder="Last Name"
          variant="outlined"
          style={{ width: '100%', marginBottom: 10 }}
          onChange={event => handleChange('lastname', event.target.value)}
          value={values.lastname}
          error={hasError('lastname')}
          helperText={hasError('lastname') ? values.errors.lastname[0] : null}
        />
        <TextField
          placeholder="First Name"
          variant="outlined"
          style={{ width: '100%', marginBottom: 10 }}
          onChange={event => handleChange('firstname', event.target.value)}
          value={values.firstname}
          error={hasError('firstname')}
          helperText={hasError('firstname') ? values.errors.firstname[0] : null}
        />
        <FormControl variant="outlined" fullWidth>
          <InputLabel>Country</InputLabel>
          <Select
            style={{ width: '100%', marginBottom: 10 }}
            value={country}
            onChange={handleCountryChange}
            label="Country"
          >
            <MenuItem value="US">+1</MenuItem>
            <MenuItem value="IN">+91</MenuItem>
          </Select>
        </FormControl>
        <TextField
          InputLabelProps={{
            shrink: true,
            classes: {
              focused: classes.labelFocused
            }
          }}
          style={{ width: '100%', marginBottom: 10 }}
          error={hasError('mobilenumber') || !!phoneError}
          fullWidth
          helperText={
            hasError('mobilenumber')
              ? values.errors.mobilenumber[0]
              : phoneError
          }
          label="Mobile Number"
          name="mobilenumber"
          required
          variant="outlined"
          color="Primary"
          onChange={handlePhoneChange}
          value={values.mobilenumber}
          inputProps={{
            maxLength: 10  // Limits input to 10 characters
          }}
          placeholder={country === 'IN' ? '98765 43210' : '(555) 123-4567'}
        />
        <TextField
          placeholder="Email address"
          variant="outlined"
          style={{ width: '100%', marginBottom: 10 }}
          onChange={event => handleChange('emailaddress', event.target.value)}
          value={values.emailaddress}
          error={hasError('emailaddress')}
          helperText={
            hasError('emailaddress') ? values.errors.emailaddress[0] : null
          }
        />
        <TextField
          placeholder="Confirm Email Address"
          variant="outlined"
          style={{ width: '100%', marginBottom: 10 }}
          onChange={event =>
            handleChange('confirmEmailaddress', event.target.value)
          }
          value={values.confirmEmailaddress}
          error={hasError('confirmEmailaddress')}
          helperText={
            hasError('confirmEmailaddress')
              ? values.errors.confirmEmailaddress[0]
              : null
          }
        />
      </Box>

      <Box className={classes.modalFooter}>
        <Button
          onClick={props.onCancel}
          style={{ marginRight: 10 }}
          variant="outlined"
          size="small">
          Cancel
        </Button>

        <Button
          // onClick={props.onCancel}
          variant="contained"
          color="primary"
          size="small"
          style={{ borderRadius: 4 }}
          disabled={!values.isValid || poploading}
          onClick={() => handleSendActivation(values)}>
          {poploading && <CircularProgress size={20} color="inherit" />}
          &nbsp;Send Account Invite
        </Button>

      </Box>
    </React.Fragment>
  );
};

SendActivation.propTypes = {
  className: PropTypes.string
};

const mapDispatchToProps = {
  sendInvite
};

const mapStateToProps = state => ({
  ehrID: state.profile && state.profile.ehrID,
  userID: state.profile && state.profile.userID,
  allPhyPtMessages:
    state.ptmessages &&
    state.ptmessages.allPhyPtMessages &&
    state.ptmessages.allPhyPtMessages.result
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(styles)(SendActivation))
);
